import { useState } from 'react';

const SITE_PASSWORD = "perma2026";

export default function PasswordGate({ children }) {
  const [authed, setAuthed] = useState(() => {
    try { return document.cookie.includes('ss_auth=1'); } catch { return false; }
  });
  const [pw, setPw] = useState('');
  const [err, setErr] = useState(false);

  const handleSubmit = () => {
    if (pw === SITE_PASSWORD) {
      document.cookie = 'ss_auth=1; max-age=2592000; path=/';
      setAuthed(true);
    } else {
      setErr(true);
      setTimeout(() => setErr(false), 2000);
    }
  };

  if (authed) return children;

  return (
    <div style={{ minHeight: '100vh', background: '#0C1117', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ textAlign: 'center', maxWidth: 340, width: '100%', padding: '0 20px' }}>
        <div style={{ width: 48, height: 48, background: 'linear-gradient(135deg, #34D399, #10B981)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, fontWeight: 700, color: '#0C1117', margin: '0 auto 16px' }}>P</div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#E0E4EA', fontFamily: "'Outfit', sans-serif", marginBottom: 4 }}>Site Scout</div>
        <div style={{ fontSize: 9, fontFamily: "'JetBrains Mono', monospace", textTransform: 'uppercase', letterSpacing: 2, color: '#4B5C6F', marginBottom: 32 }}>Perma Energy</div>
        <input
          type="password"
          value={pw}
          onChange={e => setPw(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          placeholder="Password"
          style={{
            width: '100%', padding: '12px 16px', background: '#111820', border: '1px solid ' + (err ? '#EF4444' : '#1E2A38'),
            borderRadius: 8, color: '#E0E4EA', fontSize: 14, fontFamily: "'JetBrains Mono', monospace",
            outline: 'none', boxSizing: 'border-box', marginBottom: 12
          }}
          autoFocus
        />
        <button
          onClick={handleSubmit}
          style={{
            width: '100%', padding: '12px', background: '#34D399', border: 'none', borderRadius: 8,
            color: '#0C1117', fontSize: 13, fontWeight: 600, cursor: 'pointer'
          }}
        >Enter</button>
        {err && <div style={{ marginTop: 12, fontSize: 12, color: '#EF4444' }}>Incorrect password</div>}
        <div style={{ marginTop: 24, fontSize: 9, color: '#2A3545', fontFamily: "'JetBrains Mono', monospace" }}>Confidential — Authorized access only</div>
      </div>
    </div>
  );
}
